import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface WhoAmIResponse extends BackendResponse, WhoAmIInfo {}

export interface WhoAmIParameters extends NextApiParams {}

export const whoAmI = withNextApi<WhoAmIResponse, WhoAmIParameters>("/auth/WhoAmI", {
  method: "GET",
});

export interface WhoAmIInfo {

  /** read concernId from window.cvpIdConcern */
  concernId: number | null;
  nVerifiedProfilesInConcern: number;
  hasVerifiedProfileInConcerns: number[];
  usernameFromIdentityProvider: string;
  emailFromIdentityProvider: string;
  provider: string;
  cvpIdp?: string | null;
  userIdFromIdentityProvider: string;
  idCandidate?: number;
  hasCvpToken: boolean;
  cvpTokenRejectionReason?: string | null;
  activeProfileEmail?: string | null;
  selectedProfileInConcernForThisSession: number | null;
  selectedVerifiedProfileInConcernForThisSession: number | null;
  selectedUnverifiedProfileInConcernForThisSession: number | null;
  details: WhoAmIExtraInfo;

  /** Keycloak identity providers connected since the previous session.
   *  Populated once per session (empty thereafter) for a one-time
   *  "you connected X" message. Keycloak federated-IdP links — NOT the CVP
   *  AccountLink/verified-profile concept. */
  newlyLinkedIdentityProviders: LinkedIdentityProvider[];

  /**
   * Do not use this value directly for translating.
   * Instead use the hook useEvaluatedLocale.
   */
  locale?: string;
  environment?: string;
}

export interface WhoAmIExtraInfo {
  concernName: string;
  candidateId: number | null;
  concernId: number;
}

/** A Keycloak federated identity-provider link (e.g. Visma Connect, Google).
 *  NOT the CVP AccountLink / verified-profile concept. */
export interface LinkedIdentityProvider {
  connected: boolean;
  social: boolean;
  providerAlias: string | null;
  providerName: string | null;
  displayName: string | null;
  linkedUsername: string | null;
}
